module.exports = __webpack_public_path__ + "static/img/icon_szh_wdfw_qthzc.73ba2596.png";